export async function apiFire(dispatch, payload = {}) {
    return this.$store.dispatch(dispatch, payload)
}